import { User } from "@/models/user/user";
import axios, { AxiosResponse } from "axios";
import {
  APIError,
  AuthError,
  NotFoundError,
  PermissionsError
} from "./error_service";
import { AppHeaders } from "@/models/api/api";
import { Order } from "@/models/order/order";
import { Roles } from "@/models/user/roles";

axios.defaults.baseURL = process.env.VUE_APP_API_NODE_URL;
axios.defaults.withCredentials = true;
axios.defaults.headers = { apikey: process.env.VUE_APP_API_KEY } as AppHeaders;

export default class UserService {
  public async getUserProfile(id = "me"): Promise<User> {
    let profile = {} as User;
    try {
      const res = await axios.get("/users/profile/" + id);
      profile = res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 404) {
        throw new NotFoundError(err.response.data.message, err.response.status);
      } else if (err.response && err.response.status === 403) {
        throw new PermissionsError(
          err.response.data.message,
          err.response.status
        );
      } else if (err.response && err.response.status === 401) {
        throw new AuthError(err.response.data.message, err.response.status);
      } else {
        throw new APIError(
          "Something went wrong, please try again.",
          err.response.status
        );
      }
    }
    return profile;
  }

  public async getUsersOrders(userRole: string, id = "me"): Promise<Order[]> {
    let orders;
    let url = "/users/orders";
    if (userRole !== Roles.Admin) {
      url += "/" + id;
    }
    try {
      const options = {
        withCredentials: true
      };
      const res: AxiosResponse = await axios.get(url, options);
      const order = res.data.data.orders;
      const quote = res.data.data.quotes;
      orders = order.concat(quote);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        throw new NotFoundError("Product not found.", err.response.status);
      } else if (err.response && err.response.status === 401) {
        throw new AuthError(err.response.data.message, err.response.status);
      } else {
        throw new APIError(
          "Something went wrong, please try again.",
          err.response.status
        );
      }
    }
    return orders;
  }
}
